import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StatusPageStore } from '@store';
import { StatusType } from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StatusFailedGuardService {
  constructor(public statusPageStore: StatusPageStore, private router: Router) {}

  canActivateChild(): Observable<boolean> {
    return this.checkStatusChangeForRedirect();
  }

  canActivate(): Observable<boolean> {
    return this.checkStatusChangeForRedirect();
  }

  checkStatusChangeForRedirect(): Observable<boolean> {
    return this.statusPageStore.status$.pipe(
      map((status) => {
        const isStatusError = status === StatusType.Major_Outage;

        if (isStatusError) {
          this.router.navigate(['/status']);

          return false;
        }

        return true;
      })
    );
  }
}
